import { render, staticRenderFns } from "./adminCustomerIdList.vue?vue&type=template&id=73574187&"
import script from "./adminCustomerIdList.vue?vue&type=script&lang=ts&"
export * from "./adminCustomerIdList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports